
import { AuthService } from "@/services/auth-service";
import { FormLike } from "winfakt-vue-components/src/mixins/form-like";
export default FormLike.extend({
	data(){
		return {
			password: "",
			inputsDisabled: false
		};
	},
	computed: {
		confirmDisabled():boolean{
			if (this.password == "") return true;
			return this.inputsDisabled;
		}
	},
	methods: {
		cancel(){
			this.$emit("close");
		},
		async submit(){
			this.inputsDisabled = true;
			try{
				await AuthService.totpDissable(this.password);
				this.$wf.notify(this.$ct("two-factor-auth-disabled"), "success", 3000, "check");
				this.$emit("close");
			}catch(err){
			}
			this.inputsDisabled = false;
		}
	},
	i18nEx: {
		componentPrefix: "components.account"
	}
});
